import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Check, Copy, ExternalLink } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { notiApi } from "../../lib/api-noti";

// AI docs tab: the machine-readable integration pack (/v1/docs/ai, raw at
// /llms.txt). Humans are not the audience — teams paste the raw URL (or the
// copied markdown) into their AI agent, which then builds the integration
// skill for their app. The registry half is generated from the live DB.
const RAW_URL = "https://notification.blockfint.com/llms.txt";

export function AiDocsView() {
  const page = useQuery({
    queryKey: ["noti", "docs", "ai"],
    queryFn: () => notiApi.docContent("ai"),
  });
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    if (!page.data) return;
    await navigator.clipboard.writeText(page.data.markdown);
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };

  return (
    <div className="panel docs-body">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.6rem",
          flexWrap: "wrap",
          marginBottom: "0.8rem",
        }}
      >
        <p className="muted" style={{ margin: 0, flex: "1 1 260px" }}>
          เอกสารฉบับนี้เขียนให้ <b>AI agent</b> อ่าน (คนไม่ต้องอ่านก็ได้) —
          ทีมไหนใช้ AI ช่วยเขียนโค้ด ให้ป้อน URL ดิบหรือคัดลอกทั้งหน้าให้ agent
          แล้วสั่งสร้าง skill เชื่อมต่อแอปของทีมได้ทันที ส่วน Live registry
          ท้ายเอกสาร generate สดจากฐานข้อมูล
        </p>
        <button className="btn-ghost" onClick={copy} disabled={!page.data}>
          {copied ? <Check size={14} /> : <Copy size={14} />}{" "}
          {copied ? "คัดลอกแล้ว" : "คัดลอก markdown"}
        </button>
        <a
          className="btn-ghost"
          href={RAW_URL}
          target="_blank"
          rel="noreferrer"
        >
          <ExternalLink size={14} /> /llms.txt (raw)
        </a>
      </div>
      {page.isLoading ? (
        <div className="muted">โหลดเนื้อหา…</div>
      ) : page.isError ? (
        <div className="error">{(page.error as Error).message}</div>
      ) : page.data ? (
        <div className="markdown">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {page.data.markdown}
          </ReactMarkdown>
        </div>
      ) : null}
    </div>
  );
}
